/* eslint-disable */
import { http } from '@/helpers/http';
import { transformDateToSend, transformDateView } from '@/helpers/transformDates';

const defaultRepair = {
  id: 'new',
  title: '',
  residential_complexes: [],
  updated_at: '',
  description: '',
  price: '',
  is_active: false,
  gallery: []
};

export default {
  namespaced: true,
  state() {
    return {
      list: [], // Список
      residentials: [], // Список жк
      search: '', // Поисковое слово в списке
      current: defaultRepair,
    };
  },

  mutations: {
    /* Записать новый список */
    setList (state, data) {
      state.list = data.slice();
    },

    /** Список жк */
    setListResidentials(state, data) {
      state.residentials = data.slice();
    },

    /* Установить поисковое слово */
    setSearch (state, data) {
      state.search = data;
    },

    /* Установить свойство текущего объекта */
    setValue (state, payload) {
      state.current = {
        ...state.current,
        ...payload
      }
    },

    /** Добавить картинку в галерею, вроде не нужен метод так как можно сделать через setValue */
    // addImage(state, payload) {
    //   state.current.gallery.push(payload);
    // },

    /* Очистить текущее значение */
    clearCurrent (state) {
      state.current = {
        ...state.current,
        ...defaultRepair
      }
    },

    /* Удалить из списка */
    removeFormList (state) {
      const index = state.list.findIndex(({id}) => id === state.current.id);
      state.list.splice(index, 1);
    },

    /* Установить текущий объект по идентификатору, используется только для функции копирования */
    setCurrent (state, _id) {
      const repair = state.list.find(({ id }) => id === _id )
      state.current = {
        ...state.current,
        // ...repair,
        // residential_complexes: state.current.residential_complexes.map(el => el.id),
        gallery: [],
      }
    },

    /* Заменить по идентификатору */
    replaceById (state, current) {
      const index = state.list.findIndex(({ id }) => id === current.id);
      state.list.splice(index, 1, current);
    },

    /* Добавить в список */
    addList (state, current) {
      state.list.push({...current, id: state.list.length + 1 });
    },
  },

  getters: {
    // getList: state => state.list.filter(({ title }) => title.indexOf(state.search) >= 0),

    getList: state => state.list
    .filter((el) => {
      return el.residentials_formatted.toLowerCase().indexOf(state.search.toLowerCase()) >= 0;
    })
    .map(({ id, title, residential_complexes, residentials_formatted, is_active, updated_at }) => {
      return {
        id,
        title,
        residential_complexes,
        residentials_formatted,
        is_active: is_active ? 'Да' : 'Нет',
        updated_at: transformDateView(updated_at)
      };
    }),

    getById: state => _id => state.list.find(({ id }) => id === _id ),

    getCurrent: state => state.current,

    getResidentialsComplexes: state => state.residentials
    //.map(({ id, name }) => {
    //   return {
    //     id,
    //     name,
    //   };
    // }),
    ,

    getValuesResidentialsComplexes: state => state.current.residential_complexes
    // .map( ({id, name}) => {
    //   return {
    //     id,
    //     name
    //   }
    // }),
    ,

    getFormatList: (state, getters) => {
      return getters.getList.map(obj => ({
        ...obj,
        is_active: obj.is_active ? 'Да' : 'Нет'
      }))
    }
  },

  actions: {
    async getList({ commit }) {
      try {
        const { data } = await http.get('/admin/repairs');
        commit('setList', data);
        console.log('data', data)
      } catch (e) {
        throw e;
      }
    },

    async getListResidentials({ commit }) {
      try {
        const { data } = await http.post('/admin/residentials');
        commit('setListResidentials', data);
      } catch (e) {
        throw e;
      }
    },

    async remove({ commit }, id) {
      await http.delete(`/admin/repairs/${id}`);
      commit('clearCurrent');
    },

    async getById({ commit }, id) {
      console.log('getById', id)
      if (id === null || id === 'new') {
        commit('clearCurrent');
        return;
      }

      const { data } = await http.get(`/admin/repairs/${id}`);
      commit('setListResidentials', data.residentials);
      console.log('data getById', data.repair)
      commit('setValue', {
        ...data.repair,
        residential_complexes: data.repair.residential_complexes.map( ({id}) => id)
      });
    },

    async save({ state }) {
        // Это новый элемент или редактирование?
        const isNew = state.current.id === 'new' || state.current.id === null;
        console.log("save -> state.current",  state.current)
        

        if (!isNew) {
          const { data: id } = await http.put(`/admin/repairs/${state.current.id}`, {
            id: state.current.id,
            is_active: state.current.is_active,
            title: state.current.title,
            price: state.current.price,
            description: state.current.description,
            residentials: state.current.residential_complexes,
            gallery: state.current.gallery
          });
          return id;
        } else {
          const { data: id } = await http.post('/admin/repairs/create', {
            is_active: state.current.is_active,
            title: state.current.title,
            price: state.current.price,
            description: state.current.description,
            residentials: state.current.residential_complexes,
            gallery: state.current.gallery
          });
          return id;
        }
    }
  },
};
